export const VARIABLE_TYPE = {
  DATE: 'Date',
  LIST_STRING: 'ListString',
  STRING: 'string',
  DYNAMIC_TABLE: 'dynamic_table',
  OBJECT: 'object',
  LIST_OF_STRINGS: 'listOfStrings',
  CHART_OBJECT: 'chartObject',
  FORM_OBJECT: 'formObj',
  STANDALONE: 'parent',
  STRING_TITLE_CASE: 'String',
  HTML: 'html',
  TABLE_OBJECT: 'tableObject'
}

export const PAGE_SIZE = {
  CUSTOM: 'custom',
  US_LEGAL: 'us_legal',
  US_LETTER: 'us_letter',
  US_LEGAL_LANDSCAPE_WIDTH: 816,
  US_LEGAL_LANDSCAPE_HEIGHT: 1344
}

export const ORIENTATION = {
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait'
}

export const DATE_FORMATS = {
  DD_MM_YY: "dd-MM-yy",
  DD_MM_YYYY: "dd-MM-yyyy",
  MM_DD_YYYY: "MM-dd-yyyy",
  YYYY_MM_DD: "yyyy-MM-dd",
  DD_MMM_YYYY: "dd-MMM-yyyy",
  EEEEE_MMMMM_YYYY: "EEEEE MMMMM yyyy"
}

export const VARIABLE_OBJECT_TYPES = [VARIABLE_TYPE.OBJECT, VARIABLE_TYPE.CHART_OBJECT];
export const VARIABLE_PRIMITIVE_TYPES = ['String', VARIABLE_TYPE.DATE, VARIABLE_TYPE.LIST_STRING];

export const ALL_VARIABLE_OBJECT_TYPES = [...VARIABLE_OBJECT_TYPES, VARIABLE_TYPE.FORM_OBJECT, VARIABLE_TYPE.TABLE_OBJECT];

export const EMAIL_SUBJECT_CHAR_LIMIT = 200;
export const TEMPLATE_NAME_CHAR_LIMIT = 255;